export function chunkArray<T>(array: T[], chunkSize: number): T[][] {
  if (chunkSize <= 0 || !Number.isInteger(chunkSize)) {
    throw new Error("chunkSize must be a positive integer");
  }
  const result: T[][] = [];
  array.forEach((item, index) => {
    const chunkIndex = Math.floor(index / chunkSize);
    if (!result[chunkIndex]) {
      result[chunkIndex] = [];
    }
    result[chunkIndex].push(item);
  });
  return result;
}

export async function processSequentially<T>(
  items: T[],
  processor: (item: T) => Promise<unknown>,
): Promise<void> {
  return items.reduce(
    async (promise, item) =>
      promise.then(async () => processor(item)).then(() => {}),
    Promise.resolve(),
  );
}
